import { useState, useEffect } from "react";
import { Navigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { selectUserSlice } from '../../store/userSlice'

import { user } from '../../api/auth';

export default function ProtectedRoute({ children }) {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const userData = useSelector(selectUserSlice)

    useEffect(() => {
        user().then((res) => { 
        if (res.status === 'success'){
            setIsLoggedIn(true) 
            setIsLoading(false)         
        } else {
            setIsLoggedIn(false) 
            setIsLoading(false) 
        }
        })
    }, [isLoggedIn, isLoading]);

    const isAuthenticated = Boolean(!userData.id === ''); // Example check (adjust based on auth logic)
    
    return isLoading ? null : isLoggedIn ? children : <Navigate to="/login" />;
}